import Geolocation from "../../models/Geolocation"
import SettingsService from "../../services/SettingsService"
import GeolocationService from "../../services/GeolocationService"

export interface GeolocationProps {
    showSearchRadius?: boolean
    liveGeolocation?: boolean
    mockGeolocation?: Geolocation    
}

export class GeolocationLayer {
    config: GeolocationProps | undefined
    centerMarker: google.maps.Marker | undefined
    accuracyCircle: google.maps.Circle | undefined
    searchCircle: google.maps.Circle | undefined

    mLocation: Geolocation | null = null;
    map: google.maps.Map;

    constructor(map: google.maps.Map, config: GeolocationProps | undefined) {
        this.map = map

        this.centerMarker = new google.maps.Marker({
            map: map,
            icon: {
                url: 'img/marker-circle.png',
                anchor: new google.maps.Point(10, 10)
            }
        })

        this.accuracyCircle = new google.maps.Circle({
            map: map,
            visible: false,
            strokeColor: '#0000FF',
            strokeOpacity: 0.5,
            strokeWeight: 0.5,
            fillOpacity: 0.2,
            clickable: false,
            zIndex: 2,
        })

        this.searchCircle = new google.maps.Circle({
            map: map,
            visible: false,
            strokeColor: '#000000',
            strokeOpacity: 0.5,
            strokeWeight: 0.5,
            fillColor: '#FFFF00',
            fillOpacity: 0.5,
            clickable: false,
            radius: 1,
            zIndex: 3
        })

        GeolocationService.subscribeOnUpdate((loc: Geolocation | null)=>{
            // need this extra step because this lambda captures the old liveGeolocation value
            if (config && config.liveGeolocation) {
                this.setLocation(loc)
            }
        })
        this.configure(config)
    }

    configure(config: GeolocationProps | undefined) {
        console.log("GeolocationLayer.configure")
        this.config = config
        
        if (config && config.liveGeolocation) {
            this.setLocation(GeolocationService.location())
        }
        if (config && config.mockGeolocation) {
            this.setLocation(config.mockGeolocation)
        }
    }

    location() {
        return this.mLocation
    }

    setLocation(loc: Geolocation | null) {
        if (!this.config) {
            return
        }

        this.mLocation = loc;

        this.centerMarker?.setVisible(loc != null);
        this.accuracyCircle?.setVisible(loc != null);
        this.searchCircle?.setVisible(loc != null && this.config?.showSearchRadius == true);

        if (loc) {
            let center = new google.maps.LatLng(loc.latitude, loc.longitude)

            this.centerMarker?.setPosition(center);

            this.accuracyCircle?.setCenter(center);
            this.accuracyCircle?.setRadius(loc.horizAccuracy > 0 ? loc.horizAccuracy : 50);
            this.accuracyCircle?.set('fillColor', loc.horizAccuracy > 0 ? '#0080FF' : '#FF0000')

            this.searchCircle?.setCenter(center);
            this.searchCircle?.setRadius(SettingsService.anchorSearchRadius());
        }
    }
}